import { Grid, Box, Menu, MenuItem, Button } from "@mui/material";
import { IContent } from "@vmosolutions/oc-interfaces";
import moment from "moment-timezone";
import { useState, MouseEvent } from "react";
import { useDispatch } from "react-redux";
import { openWindow } from "src/redux/actions/Mosaic.Actions";
import { getPreviewViewId, isPreviewable } from "src/utils/contentPreview";
import { IContentCellProps } from "src/pages/FlightStatus/FlightStatusWindow";
import { BoxWithX } from "../BoxWithX";

export function ContentQuickAccess(props: IContentCellProps): JSX.Element {
  const { data, flightId } = props;
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (): void => {
    setAnchorEl(null);
  };
  return (
    <Grid container spacing={0}>
      <Grid item xs={12} sx={{ height: "100%" }}>
        {data && data.hasOwnProperty("content") && data.content.length === 0 && <BoxWithX />}
        {data &&
          data.hasOwnProperty("content") &&
          data.content.map((contentDetails: IContent, key: number) => {
            const fileName = contentDetails.displayTitle
              ? `${contentDetails.contentType.title} - ${contentDetails.displayTitle}`
              : contentDetails.contentType.title;
            return (
              <Box key={key}>
                {key <= 2 && (
                  <Box
                    sx={{
                      cursor: "pointer",
                      fontSize: "0.8em",
                      display: "flex",
                      justifyContent: "space-between",
                      minWidth: "200px",
                    }}
                    key={key}
                    onClick={() => {
                      const viewId = getPreviewViewId(contentDetails.fileType);
                      if (isPreviewable(contentDetails.fileType) && viewId) {
                        dispatch(openWindow(fileName, viewId, [], { file: contentDetails }, "content", true));
                      } else {
                        dispatch(
                          openWindow(
                            "Edit Content",
                            "ManageContentWindow",
                            [],
                            { contentId: contentDetails._id },
                            "content"
                          )
                        );
                      }
                    }}
                  >
                    <Box>{fileName}</Box>
                    <Box>{moment(contentDetails.createdAt).utc().format("MMM DD, YYYY HH:mm")}</Box>
                  </Box>
                )}
              </Box>
            );
          })}
        {data && data.hasOwnProperty("content") && data.content.length > 2 && (
          <>
            <Button
              id={`content-button-${flightId}`}
              aria-controls={open ? `content-menu-${flightId}` : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
              size="small"
              variant="contained"
              color="info"
              sx={{ p: 0, px: 1, mt: 0.5 }}
            >
              + {data.content.length - 2} other files
            </Button>
            <Menu
              id={`content-menu-${flightId}`}
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": `content-button-${flightId}`,
              }}
            >
              {data &&
                data.hasOwnProperty("content") &&
                data.content.map((contentDetails: IContent, key: number) => {
                  if (key > 2) {
                    const fileName = contentDetails.displayTitle
                      ? `${contentDetails.contentType.title} - ${contentDetails.displayTitle}`
                      : contentDetails.contentType.title;
                    return (
                      <MenuItem
                        key={key}
                        sx={{ fontSize: "0.8em", display: "flex", justifyContent: "space-between", minWidth: "300px" }}
                        onClick={() => {
                          const viewId = getPreviewViewId(contentDetails.fileType);
                          if (isPreviewable(contentDetails.fileType) && viewId) {
                            dispatch(openWindow(fileName, viewId, [], { file: contentDetails }, "content", true));
                          } else {
                            dispatch(
                              openWindow(
                                "Edit Content",
                                "ManageContentWindow",
                                [],
                                { contentId: contentDetails._id },
                                "content"
                              )
                            );
                          }
                          handleClose();
                        }}
                      >
                        <Box>{fileName}</Box>
                        <Box>{moment(contentDetails.createdAt).utc().format("MMM DD, YYYY HH:mm")}</Box>
                      </MenuItem>
                    );
                  } else {
                    return null;
                  }
                })}
            </Menu>
          </>
        )}
      </Grid>
    </Grid>
  );
}
